import axios from "@/api/axiosInstance";

export const exportResourceLibraryReport = async (): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/admin/reports/resource-library",
    { responseType: "blob" },
  );

  return response.data;
};
